(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-main-collection"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-su-sort][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-su-sort][open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["su-main-product"]) return;
  try {
    
  document.querySelectorAll('[data-su-product]').forEach((root) => {
    const select = root.querySelector('[data-su-variant]');
    const data = root.querySelector('[data-su-variants]');
    if (!select || !data) return;

    const variants = JSON.parse(data.textContent);
    const price = root.querySelector('[data-su-price]');
    const compare = root.querySelector('[data-su-compare]');
    const add = root.querySelector('[data-su-add]');
    const addLabel = root.querySelector('[data-su-add-label]');
    const stock = root.querySelector('[data-su-stock]');
    const money = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(cents / 100);

    select.addEventListener('change', () => {
      const variant = variants.find((v) => String(v.id) === select.value);
      if (!variant) return;

      price.textContent = money(variant.price);
      const onSale = variant.compare_at_price > variant.price;
      compare.hidden = !onSale;
      if (onSale) compare.textContent = money(variant.compare_at_price);

      add.disabled = !variant.available;
      addLabel.textContent = variant.available ? add.dataset.labelAvailable : add.dataset.labelSoldOut;
      stock.textContent = variant.available ? stock.dataset.labelIn : stock.dataset.labelOut;
      stock.classList.toggle('su-product__stock--out', !variant.available);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
